import { render } from "./GenericFailed.vue?vue&type=template&id=2af08ffc&scoped=true"
import script from "./GenericFailed.vue?vue&type=script&lang=js"
export * from "./GenericFailed.vue?vue&type=script&lang=js"

import "./GenericFailed.vue?vue&type=style&index=0&id=2af08ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af08ffc"]])

export default __exports__